'use client';

import React from 'react';
import { Search, X, ChevronDown } from 'lucide-react';

const FARMS = ['all', 'Idudi Poultry Farm', 'Kampala Demo Farm'];
const TYPES = ['all', 'Broiler', 'Layer', 'Breeder', 'Local/Indigenous'];
const STATUSES = ['all', 'active', 'planned', 'completed', 'sold', 'closed', 'transferred'];
const HOUSES = ['all', 'House A1', 'House A2', 'House B1', 'House C1', 'House D2', 'House E1', 'Layer House 01', 'Layer House 02', 'Layer House 03', 'Layer House 04', 'Breeder House 01', 'Breeder House 02', 'Free Range Area'];

interface Props {
  search: string; onSearch: (v: string) => void;
  filterFarm: string; onFarm: (v: string) => void;
  filterType: string; onType: (v: string) => void;
  filterStatus: string; onStatus: (v: string) => void;
  filterHouse: string; onHouse: (v: string) => void;
}

function FilterSelect({ id, value, options, onChange, label }: { id: string; value: string; options: string[]; onChange: (v: string) => void; label: string }) {
  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="select-field pr-7 text-sm"
        style={{ height: '36px', minWidth: '130px' }}
        aria-label={label}
      >
        {options.map((opt) => (
          <option key={`${id}-${opt}`} value={opt}>
            {opt === 'all' ? `All ${label}s` : opt.charAt(0).toUpperCase() + opt.slice(1)}
          </option>
        ))}
      </select>
      <ChevronDown size={12} className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground" />
    </div>
  );
}

export default function FlockTableFilters({ search, onSearch, filterFarm, onFarm, filterType, onType, filterStatus, onStatus, filterHouse, onHouse }: Props) {
  const hasFilters = search || filterFarm !== 'all' || filterType !== 'all' || filterStatus !== 'all' || filterHouse !== 'all';

  return (
    <div
      className="flex flex-wrap items-center gap-2 p-3 rounded-lg border mb-4"
      style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}
    >
      {/* Search */}
      <div className="relative flex-1" style={{ minWidth: '200px', maxWidth: '280px' }}>
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search flocks, breeds, houses..."
          className="input-field pl-9 text-sm"
          style={{ height: '36px' }}
        />
        {search && (
          <button onClick={() => onSearch('')} className="absolute right-2 top-1/2 -translate-y-1/2 btn-ghost p-0.5">
            <X size={12} />
          </button>
        )}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <FilterSelect id="ff-farm" value={filterFarm} options={FARMS} onChange={onFarm} label="Farm" />
        <FilterSelect id="ff-type" value={filterType} options={TYPES} onChange={onType} label="Type" />
        <FilterSelect id="ff-status" value={filterStatus} options={STATUSES} onChange={onStatus} label="Status" />
        <FilterSelect id="ff-house" value={filterHouse} options={HOUSES} onChange={onHouse} label="House" />
      </div>

      {hasFilters && (
        <button
          onClick={() => { onSearch(''); onFarm('all'); onType('all'); onStatus('all'); onHouse('all'); }}
          className="btn-ghost text-xs py-1.5 px-2 ml-auto"
          style={{ color: 'var(--danger)' }}
        >
          <X size={12} />
          Clear filters
        </button>
      )}
    </div>
  );
}